export default __webpack_public_path__ + "static/media/largeSettings.30f1ec8f.svg";